module.exports = __webpack_public_path__ + "static/media/tool4.f6a03f3a.png";